import React, { Component, Fragment } from "react";
import withStyles from "elevate-ui/withStyles";
import ChevronLeft from "elevate-ui-icons/ChevronLeft";
import ChevronRight from "elevate-ui-icons/ChevronRight";
import classNames from "classnames";
import { stringify } from "querystring";
import assign from "lodash/assign";

import type { $Pagination } from "flow/types";

type $Props = {
  pagination: $Pagination,
  path: string,
  handleSearch: (null | Event, Object) => void,
  className?: Object,
  query: Object,
  classes: Object,
};

class Pagination extends Component<$Props> {
  componentDidUpdate(prevProps) {
    if (this.props.pagination !== prevProps.pagination) {
      window.scrollTo(0, 0);
    }
  }

  static defaultProps = {
    handleSearch: () => {}, // noop to prevent `handleSearch does not exist`
  };

  render() {
    const {
      pagination,
      path,
      handleSearch,
      classes,
      className,
      query,
    } = this.props;

    const showPagination = pagination.count > pagination.limit;

    const showPrevious = pagination.prevOffset >= 0;
    const showNext = pagination.nextOffset < pagination.count;
    if (!(showPrevious || showNext)) {
      return null;
    }

    const parentClass = classNames(classes.root, className);

    const limit =
      query && query.limit && Number(query.limit) > 0
        ? Number(query.limit)
        : Number(pagination?.limit || 12);

    let nextOffset =
      query && query.offset && Number(query.offset) >= 0
        ? Number(query.offset) + limit
        : limit;

    const nextFilters = assign({}, query || {}, { offset: nextOffset });

    const nextUrl = `${path}?${stringify(nextFilters)}`;

    let prevOffset =
      query && query.offset && Number(query.offset) >= 0
        ? Number(query.offset) - limit
        : 0;
    if (prevOffset < 0) {
      prevOffset = 0;
    }
    const prevFilters = assign({}, query, { offset: prevOffset });
    const prevUrl = `${path}?${stringify(prevFilters)}`;

    return (
      <Fragment>
        {showPagination && (
          <div className={parentClass}>
            <div className={classes.paginationContainer}>
              {showPrevious ? (
                <a
                  href={prevUrl}
                  onClick={(e) => handleSearch(e, prevFilters)}
                  className={classes.paginationLink}
                  title="Back to previous page"
                >
                  <ChevronLeft style={{ marginRight: "4px" }} size={16} /> Back
                </a>
              ) : (
                <a className={classes.paginationLinkDisabled}>
                  <ChevronLeft style={{ marginRight: "4px" }} size={16} /> Back
                </a>
              )}
              {showNext ? (
                <a
                  href={nextUrl}
                  onClick={(e) => handleSearch(e, nextFilters)}
                  className={classes.paginationLink}
                  title="Next page"
                >
                  Next{" "}
                  <ChevronRight
                    style={{ marginLeft: "4px", marginTop: "2px" }}
                    size={16}
                  />
                </a>
              ) : (
                <a className={classes.paginationLinkDisabled}>
                  Next{" "}
                  <ChevronRight
                    style={{ marginLeft: "4px", marginTop: "2px" }}
                    size={16}
                  />
                </a>
              )}
            </div>

            <div className={classes.resultsContainer}>
              {pagination.formattedCount && (
                <div className={classes.paginationText}>
                  <span className={classes.paginationResults}>
                    Showing Results
                  </span>
                  <div>
                    <span className={classes.paginationNumber}>
                      {pagination.currentOffset + 1} -{" "}
                      {pagination.currentUpperOffset}
                    </span>{" "}
                    of
                    <span className={classes.paginationNumber}>
                      {pagination.formattedCount}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default withStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    margin: "24px 0px 16px",
  },
  paginationLink: {
    display: "flex",
    alignItems: "center",
    color: theme.colors.black,
    padding: "12px",

    "&:hover": {
      textDecoration: "none",
      cursor: "pointer",
      color: theme.colors.gray700,
    },
    "&:focus": {
      color: theme.colors.black,
      textDecoration: "none",
      outline: "none",
    },
  },
  paginationResults: {
    color: theme.colors.gray700,
    fontSize: "14px",
    marginBottom: "8px",
  },
  paginationText: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: theme.colors.gray700,
    fontSize: "15px",
    letterSpacing: ".4px",
    margin: "15px",
  },
  paginationNumber: {
    fontWeight: "600",
    color: theme.colors.black,
    fontSize: "15px",
    letterSpacing: ".3px",
    padding: "0px 6px",
  },
  paginationContainer: {
    display: "flex",
    alignItems: "center",
    width: "210px",
    justifyContent: "space-between",
  },
  pagesContainer: {
    display: "flex",
    padding: "0px 24px",
  },
  paginationLinkDisabled: {
    display: "flex",
    alignItems: "center",
    color: theme.colors.gray200,
    padding: "12px",

    "&:hover": {
      color: theme.colors.gray200,
      textDecoration: "none",
      cursor: "pointer",
    },
    "&:focus": {
      color: theme.colors.gray200,
      textDecoration: "none",
      outline: "none",
    },
  },
  resultsContainer: {
    display: "flex",
    marginTop: "24px",
    padding: "0px 20px",
    background: "#fafafa",
  },
}))(Pagination);
